import { eventBus } from "@kunduz/utility-common";
import { type AxiosError } from "axios";

export function onBannedErrorMiddleware(error: AxiosError) {
  if (
    !!error.response?.config?.headers?.Authorization &&
    error.response?.status == 401
  ) {
    eventBus.emit("user_banned");
  } else {
    return Promise.reject(error);
  }
}
